<template>
  <div>
    <ul class="form-message-list" v-if="formFieldMessages.length > 1">
      <li
        v-for="(message, i) in formFieldMessages"
        :key="i"
        class="error form-message ba-text-sm"
      >
        {{ message }}
      </li>
    </ul>
    <p v-else class="error form-message ba-text-center ba-text-sm">
      {{ formFieldMessages[0] || formErrorMessage }}
    </p>
  </div>
</template>

<script>
export default {
  name: "vis-form-messages",
  props: {
    formErrorMessage: {
      type: String,
      default: null
    },
    formFieldMessages: {
      type: Array,
      default: () => []
    }
  }
};
</script>
